import { useTranslation } from "react-i18next";

import kentaLogo from "assets/KENTA_4.0.png";

import {
  Container,
  Content,
  LogoContainer,
  Title,
  Subtitle,
  Button,
  ButtonContent,
} from "./styles";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <LogoContainer>
          <img src={kentaLogo} alt="Logo" width="240" height="90" />
        </LogoContainer>

        <Title>404</Title>
        <Subtitle>{t("notFound.title")}</Subtitle>
        <p>{t("notFound.description")}</p>

        <Button href="/">
          <ButtonContent>
            <span>{t("notFound.backToHome")}</span>
          </ButtonContent>
        </Button>
      </Content>
    </Container>
  );
};

export default NotFoundPage;
